<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="1200">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row>
      <v-col>
        <v-text-field
          label="Group Name"
          v-model="groupName"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          label="Setting Name"
          v-model="settingName"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          v-model="notes"
          label="Notes"
          :outlined="outlinedInputs"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-switch label="Default Value" v-model="settingValue"></v-switch>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <v-row v-if="debug">
      <v-col cols="12">
        <pre>{{ value }}</pre>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
export default {
  name: "available-access-setting-edit-dialog",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      debug: false,
      settingName: this.value ? this.value.settingName : "",
      groupName: this.value ? this.value.groupName : "",
      settingValue: this.value && this.value.settingValue ? true : false,
      notes: this.value ? this.value.notes : "",
    };
  },
  components: { BasicDialog },

  computed: {
    editorTitle() {
      return this.value
        ? "Edit Available Access Setting"
        : "Create Available Access Setting";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return (
        this.settingName.toString() != "" && this.groupName.toString() != ""
      );
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.settingName = newVal.settingName;
        this.groupName = newVal.groupName;
        this.settingValue = newVal.settingValue.toString() == "true";
        this.notes = newVal.notes;
      } else {
        this.settingName = "";
        this.groupName = "";
        this.settingValue = false;
        this.notes = "";
      }
    },
  },
  methods: {
    onSave() {
      this.$emit("input", {
        id: this.value && this.value.id ? this.value.id : undefined,
        settingName: this.settingName,
        groupName: this.groupName,
        settingValue: this.settingValue,
        notes: this.notes,
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/admin/available-access-settings/AvailableAccessSettingEditDialog.vue